import styled from 'styled-components';

import { Head, Ceil } from 'components/ConvertorTable/styles';

import { mediaQueryMobileLargeMin } from 'styles/variables';

// TODO: Duplicate AllBanksTable styles
export const RatesHead = styled(Head)`
  display: none;

  @media all and ${mediaQueryMobileLargeMin} {
    display: table-cell;
  }
`;

// TODO: Duplicate AllBanksTable styles
export const RatesCeil = styled(Ceil)``;

export const BankAmount = styled.span`
  font-weight: bold;
  font-size: 16px;
`;
